var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-user-multi-picker"},[_c('i-multi-picker',{attrs:{"label-counter":_vm.currentCollection === 'exchange' ? 'seat(s)' : 'user(s)',"label":_vm.label,"value":_vm.value,"fetch-options":_vm.fetchUsers,"option-label":"name","option-value":"userId"},on:{"input":$val => _vm.$emit('input',$val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }